import React from "react";
import Container from 'react-bootstrap/Container';
import PropTypes, { InferProps } from 'prop-types';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Button from 'react-bootstrap/Button';

const propTypes = {
  children: PropTypes.element,
  progress: PropTypes.number.isRequired,
  setSchedule: PropTypes.func,
  scheduleTitle: PropTypes.string,
  hideBackBtn: PropTypes.bool.isRequired,
  hideForwardBtn: PropTypes.bool.isRequired,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
};

export default function Layout(props: InferProps<typeof propTypes>): JSX.Element {
  const { children, progress, setSchedule, scheduleTitle, hideBackBtn, hideForwardBtn, handleBack, handleNext } = props;

  return (
    <div className="layout">
      <Container fluid>
        <ProgressBar animated key="progress_bar" now={progress} />
        {setSchedule && <Button variant="primary" type="button" key="reset_button" size="lg" className="themed-btn themed-btn--primary" onClick={() => setSchedule()}>Restart</Button>}
        {scheduleTitle && <h2 className="schedule-title">{scheduleTitle}</h2>}
        {children}
        <div className="nav-buttons">
          <Button hidden={hideBackBtn} variant="outline-primary" type="button" size="lg" disabled={!handleBack} key="back_button" className="themed-btn themed-btn--secondary back-btn" onClick={() => handleBack()}>Back</Button>
          <Button hidden={hideForwardBtn} variant="primary" type="button" size="lg" disabled={!handleNext} key="forward_button" className="themed-btn themed-btn--primary forward-btn" onClick={() => handleNext()}>Next</Button>
        </div>
      </Container>
    </div>
  );
}
